export function setUnion<T>(lhs: ReadonlySet<T>, rhs: ReadonlySet<T>): Set<T> {
  return lhs.union ? lhs.union(rhs) : new Set([...lhs, ...rhs]);
}

export function setIsSuperSetOf<T>(superset: ReadonlySet<T>, subset: Readonly<Iterable<T>>): boolean {
  if (superset.isSupersetOf) return superset.isSupersetOf(new Set(subset));
  if (Array.isArray(subset)) { // likely case
    if (superset.size < subset.length) return false;
  } else if (subset instanceof Set) { // less likely case, but still more efficient to check size first.
    if (superset.size < subset.size) return false;
  }
  for (const value of subset)
    if (!superset.has(value)) return false;
  return true;
}

export function setEquals<T>(lhs: ReadonlySet<T>, rhs: ReadonlySet<T>): boolean {
  if (lhs.size !== rhs.size) return false;
  if (lhs.symmetricDifference) return lhs.symmetricDifference(rhs).size === 0;
  return setUnion(lhs, rhs).size === lhs.size;
}

export function setAdd<T>(set: Readonly<Set<T>>, value: T): Set<T> {
  if (set.has(value)) return set;
  const newSet = new Set(set);
  newSet.add(value);
  return newSet;
}

export function setDelete<T>(set: Readonly<Set<T>>, value: T): Set<T> {
  if (!set.has(value)) return set;
  const newSet = new Set(set);
  newSet.delete(value);
  return newSet;
}
